import React from "react";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { companyService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";

class ChangeCompanyNameModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isSaving: false,
			name: props.partner_company.name || "",
			errors: {},
		};
	}

	handleSubmit = async () => {
		const { name } = this.state;
		const { partner_company, t } = this.props;
		this.setState({ isSaving: true, errors: {} });

		const response = await companyService.update({
			...partner_company,
			name,
		});

		if (response.ok) {
			this.setState({ isSaving: false });
			toastr.success(t("common.success"), t("common.changesSaved"));
			if (this.props.onSuccess) this.props.onSuccess();
			this.props.handleClose();
		} else {
			this.setState({ isSaving: false, errors: errorFormating(response) });
		}
	};

	render() {
		const { isSaving, name, errors } = this.state;
		const { t } = this.props;

		return (
			<>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="companyName">
						<FormLabel>{t("subscriptionsPage.companyName")}</FormLabel>
						<FormControl
							type="text"
							value={name}
							onChange={(e) => this.setState({ name: e.target.value })}
							isInvalid={!!errors.name}
						/>
						<FormControl.Feedback type="invalid">
							{errors.name}
						</FormControl.Feedback>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t("common.close")}
					</button>
					<SubmitButton
						type="button"
						isLoading={isSaving}
						text={t("common.save")}
						loadingText={t("common.saving")}
						onClick={this.handleSubmit}
					/>
				</div>
			</>
		);
	}
}

export default withTranslation()(ChangeCompanyNameModal);
